import {
  BathtubOutlined,
  AssistWalkerOutlined,
  WcOutlined,
  AccessibilityNewOutlined,
  CleaningServicesOutlined,
  PsychologyOutlined,
  MedicationOutlined,
  RestaurantOutlined,
  FavoriteBorderOutlined,
  LocalHospitalOutlined,
  DirectionsRunOutlined,
  NightShelterOutlined,
  CheckroomOutlined,
} from 'views/icons';

export const SERVICE_ICONS_TABLE = Object.freeze({
  DementiaAlzheimers: FavoriteBorderOutlined,
  ParkinsonsDisease: AccessibilityNewOutlined,
  StrokeRecovery: DirectionsRunOutlined,
  Diabetes: LocalHospitalOutlined,
  COPDRespiratory: LocalHospitalOutlined,
  CancerChemotherapy: LocalHospitalOutlined,
  PalliativeCare: FavoriteBorderOutlined,
  MobilitySupport: AssistWalkerOutlined,
  MealPrep: RestaurantOutlined,
  MedicationSupport: MedicationOutlined,
  MemoryCare: PsychologyOutlined,
  Housekeeping: CleaningServicesOutlined,
  Bathing: BathtubOutlined,
  Toiletting: WcOutlined,
  OvernightCare: NightShelterOutlined,
  Dressing: CheckroomOutlined,
  BriefChanging: AccessibilityNewOutlined,
});

